import React, { useState, ChangeEvent, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../App/store"; // Update based on your actual store

import Product_1 from "../../../Assets/Products/Product_1.jpeg";
import Product_2 from "../../../Assets/Products/Product_2.png";
import Product_3 from "../../../Assets/Products/Product_3.png";
import Product_4 from "../../../Assets/Products/Product_4.png";
import Product_5 from "../../../Assets/Products/Product_5.png";

import { FaBolt, FaCartPlus, FaRegCreditCard, FaShoppingCart } from "react-icons/fa";
import "./Product.css";

import Header from "../../Header/Navbar";
import 'react-medium-image-zoom/dist/styles.css';

import { sizes, sizesDetails } from "../../../Data/StoreData";

import { IoMdPrint } from "react-icons/io";
import paymentImage from "../../../Assets/Payment/paywithplux.png";
import ProductImageZoom from "../../Card/ProductImagezoom";
import LatestProducts from "../../LatestProduct/LatestProduct";
import { useLocation, useNavigate } from "react-router-dom";
import { defaultStockItem, IStockItem, ProductDetails } from "../../../Interface/Product.interface";
import AdditionalInfo from "../AdditonInfo/AdditionalInfo";
import toast from "react-hot-toast";
import { getStoredAuth } from "../../../StoreData/authUser";
import { createCartPayload } from "../../../CartItems/CartItems";
import { fetchOrderFailed, fetchOrderSuccess } from "../../../Slice/Order.Slice";
import { GetBuyOrders, GetReview } from "../../../Action/buy.Actions";
import { triggerBuyRefresh } from "../../../Slice/Buy.Slice";
import { CartItemsData } from "../../../Action/order.Action";
import { fetchPosCustomerDetails, fetchPosItemOffers } from "../../../Action";



const Product: React.FC = () => {
  const productImg: string[] = [Product_1, Product_2, Product_3, Product_4, Product_5];
  const [currentImg, setCurrentImg] = useState<number>(0);

  const [quantity, setQuantity] = useState<number>(1);
  const [imagePath, setImagePath] = useState<string>("")
  const [fetchProductDetails, setFetchProductDetails] = useState<IStockItem>(defaultStockItem)
  const [discoundValues, setDiscountValues] = useState<number>(0)
  const navigate = useNavigate()

  const location = useLocation();
  const stateValue = location.state as IStockItem;



 


  const dispatch = useDispatch<AppDispatch>();

  const { isOrderPlaced } = useSelector((state: any) => state.orders)
  const { isMemberIdStatus } = useSelector((state: any) => state.BuyOrder)
  const { user } = useSelector((state: any) => state.auth)
  const { postofferStockitems, PosCustomerDetails } = useSelector((state: any) => state.pos)



  const [initialLoad, setInitialLoad] = useState(true);


  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false); // Skip first load
      return;
    }

    if (isOrderPlaced === true) {
      const storedAuth = getStoredAuth();

      const parsed = JSON.parse(storedAuth);
      const user = parsed[0];
      dispatch(GetBuyOrders(user?.mid))

      dispatch(triggerBuyRefresh())

      toast.success('Item added to cart!');
      dispatch(fetchOrderFailed());
    }
  }, [isOrderPlaced, dispatch]);



  useEffect(() => {
    initialApi()
  }, [dispatch, user])



  useEffect(() => {
    if (!fetchProductDetails) return;

    // This should return matching offer
    addToCart(fetchProductDetails, postofferStockitems); // This will recalculate discount, totals, etc.
  }, [quantity]);


  const initialApi = async () => {
    try {
      const customerRes: any = await dispatch(fetchPosCustomerDetails(user[0]?.mobileno)).unwrap();
      const memberType = customerRes?.memberType;

      if (memberType) {
        const offersRes: any = await dispatch(fetchPosItemOffers(memberType)).unwrap();

        console.log("Post offer items directly from API:", offersRes);
      } else {
        console.warn("memberType not found in customer response");
      }
    } catch (err) {
      console.error("initialApi failed", err);
    }
  };





  useEffect(() => {
    if (!stateValue) {
      navigate('/')
    }
    else {
      setImagePath(stateValue?.FilePath ?? '');
      setFetchProductDetails(stateValue)
      dispatch(GetReview(stateValue.itemid))


    }

  }, [stateValue, navigate])


  const btcRate = fetchProductDetails?.BTCSellingRate ?? 0;
  const totalPrice = btcRate * quantity;

  const getDiscount = (qty: number) => {
    if (qty < 5) return 0;  // No discount for quantities less than 5
    if (qty === 5) return 1.50;  // Discount for exactly 5 items

    // For qty > 5, increment the discount based on the quantity
    const additionalQty = qty - 5;  // This calculates the number of items after 5
    const discountIncrement = 0.30;  // The incremental increase in discount for each additional qty

    // Starting at ₹1.50 for qty 5, adding ₹0.30 per additional item
    return 1.50 + additionalQty * discountIncrement;
  };


  // Total amount (without discount)
  const totalAmount = fetchProductDetails?.BTCSellingRate * quantity;

  const discount = getDiscount(quantity);

  // Net total after applying discount
  const netTotal = totalAmount - discoundValues;


  const productDetails = {
    qty: 2,
    mrp: 500,
    sellingPrice: 450,
    discount: 50,
    totalAmount: 900,
    netTotal: 850
  };


  const decrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  // Increase quantity (only if within stock)
  const increment = () => {
    if (quantity < fetchProductDetails?.stock) {
      setQuantity(quantity + 1);
    }
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value)) {
      if (value > 0 && value <= fetchProductDetails?.stock) {
        setQuantity(value);
      } else if (value > fetchProductDetails?.stock) {
        setQuantity(fetchProductDetails?.stock);
      }
    }


  };

 

  const addToCart = (fetchProductDetails: IStockItem, postofferStockitems: any[]) => {

    let discountValue = 0;
    const qty = quantity;
    const sellingRate = fetchProductDetails?.BTCSellingRate!;
    const sumTotal = qty * sellingRate;

    if (Array.isArray(postofferStockitems)) {
      const now = new Date();

      const matchedItemOffers = postofferStockitems.filter(
        offer =>
          offer?.AssinOfferType === "products" &&
          offer?.itemId === fetchProductDetails?.itemid &&
          now < new Date(offer?.effectivetoDate)
      );

      const matchedCategoryOffers = postofferStockitems.filter(
        offer =>
          offer?.AssinOfferType === "category" &&
          offer?.categoryId === fetchProductDetails?.subcategory &&
          now < new Date(offer?.effectivetoDate)
      );

      const allMatchedOffers = [...matchedItemOffers, ...matchedCategoryOffers];

      allMatchedOffers.forEach(offer => {
        const fromQV = parseFloat(offer?.From_QV);
        const toQV = parseFloat(offer?.To_QV);
        const discountPV = parseFloat(offer?.Discount_PV);

        if (offer?.offertype === "Value Discount") {
          if (offer?.Dis_Mode === "Value") {
            if (sumTotal >= fromQV && sumTotal <= toQV) {
              discountValue = discountPV;
            }
          } else if (offer?.Dis_Mode === "Dis%") {
            if (sumTotal >= fromQV && sumTotal <= toQV) {
              discountValue = sumTotal * (discountPV / 100);
            }
          }
        }

        if (offer?.offertype === "Qty Discount") {
          if (offer?.Dis_Mode === "Value") {
            if (qty >= fromQV && qty <= toQV) {
              discountValue = discountPV;
            }
          } else if (offer?.Dis_Mode === "Dis%") {
            if (qty >= fromQV && qty <= toQV) {
              discountValue = qty * sellingRate * (discountPV / 100);
            }
          }
        }
      });
    }



    const finalItem = {
      ...fetchProductDetails,
      quantity: qty,
      discountValue: parseFloat((discountValue ?? 0).toFixed(2)),
      totalAmount: qty * fetchProductDetails?.BTCSellingRate!,
      netTotal: qty * fetchProductDetails?.BTCSellingRate! - (discountValue ?? 0),
    };

    setDiscountValues(finalItem.discountValue);
   
  };





  const handleAddToCart = async () => {

    const storedAuth = getStoredAuth();
    if (storedAuth) {
      try {
        const parsed = JSON.parse(storedAuth);
        const user = parsed[0];
        if (user?.membername) {
          const payload = createCartPayload(user?.mid, fetchProductDetails, quantity, totalPrice, discoundValues, totalAmount, netTotal)
          if (payload) {
            await dispatch(CartItemsData(payload))
            dispatch(triggerBuyRefresh())
          }
          return;
        }
      } catch (err) {
        console.error('Failed to parse auth:', err);
      }
    }

    // 🚫 Not authenticated
    toast.error('Please login to add items to your cart.');
    navigate('/loginSignUp');

  }


  const handleOnBuyNow = () => {

    const storedAuth = getStoredAuth();

    const parsed = JSON.parse(storedAuth);
    const user = parsed[0];
    dispatch(GetBuyOrders(user?.mid))

    if (isMemberIdStatus) {
      navigate('/cart')
    }
  }

  const handlePrint = () => {
    window.print();
  };


  const cellStyle = {
    border: "1px solid #ccc",
    padding: "8px",
    backgroundColor: "#ffffff"
  };

  const headerCellStyle = {
    ...cellStyle,
    backgroundColor: "#e0e0e0",
    fontWeight: "bold"
  };

  const authData = getStoredAuth();
  const userData = authData ? JSON.parse(authData) : [];

  const memberId = userData?.[0]?.mid || 0;
  return (
    <>

      <div className="productSection">
        <div className="productShowCase">
          <div className="productGallery">
            <LatestProducts />
            <div className="productFullImg">
              <div className="productImageWrapper">
                <ProductImageZoom image={imagePath} />
              </div>
            </div>

            {/* <div className="productThumb">
              {productImg.slice(0, 4).map((img, index) => (
                <img key={index} src={img} onClick={() => setCurrentImg(index)} alt="" />
              ))}
            </div> */}
          </div>

          <div className="productDetails">
            <div className="productBreadcrumb">
              <div className="breadcrumbLink"></div>
            </div>

            <div className="productName">
              <h1 style={{ color: '#00a1cb', fontWeight: 'bold' }}>{fetchProductDetails?.itemname}</h1>
            </div>



            <div className="productPrice">
              <h3>₹ {totalPrice.toFixed(2)} inc Tax </h3>
            </div>

            <h3 style={{ textDecoration: 'line-through', color: '#888', fontSize: '0.9em' }}>
              ₹{fetchProductDetails.Mrprate.toFixed(2)} <span style={{ fontStyle: 'italic' }}>Inc tax</span>
            </h3>

            <div className="productDescription">
              <p>
                {fetchProductDetails.itemdescription}
              </p>
            </div>

            <div>
              <span style={{ fontWeight: 'bold' }}>Total Price :</span>
              <span style={{ fontWeight: 'bold', color: '#00a1cb' }}>
                ₹{totalPrice.toFixed(2) + " "}
              </span>
              inc Tax
            </div>



            <div className="productDetails">
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ccc"
                }}
              >
                <thead>
                  <tr>
                    <th style={headerCellStyle}>Qty</th>
                    <th style={headerCellStyle}>Selling Rate</th>
                    <th style={headerCellStyle}>Discount</th>
                    <th style={headerCellStyle}>Total Amount</th>
                    <th style={headerCellStyle}>Net Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={cellStyle}>{quantity}</td>
                    <td style={cellStyle}>{fetchProductDetails.BTCSellingRate}</td>
                    <td style={cellStyle}>{discoundValues}</td>
                    <td style={cellStyle}>{totalAmount.toFixed(2)}</td>
                    <td style={cellStyle}>{netTotal.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>


            <div className="productCartQuantity">
              {fetchProductDetails?.stock > 0 ? (
                <div className="productQuantity">
                  <label style={{ marginTop: '15px', fontWeight: 'bold' }}>Qty</label>
                  <button onClick={decrement} disabled={quantity <= 1}>-</button>
                  <input
                    type="text"
                    value={quantity}
                    onChange={handleInputChange}
                    placeholder="qty"
                  />
                  <button onClick={increment} disabled={quantity >= fetchProductDetails?.stock}>+</button>
                  <div
                    style={{
                      marginTop: '20px',
                      color: fetchProductDetails?.stock - quantity <= 3 ? 'red' : 'inherit',
                      fontWeight: fetchProductDetails?.stock - quantity <= 3 ? 'bold' : 'normal',
                    }}
                  >
                    {fetchProductDetails?.stock - quantity} item(s) remaining
                  </div>


                </div>
              ) : (
                <div className="productOutOfStock">
                  <p style={{ color: 'red', fontWeight: 'bold' }}>Unavailable Stock</p>
                </div>
              )}
            </div>

            <div className="productCartActions">
              {fetchProductDetails?.stock > 0 && (
                <button onClick={handleAddToCart}>
                  <FaShoppingCart style={{ marginRight: '10px' }} />
                  Add to Cart
                </button>
              )}

              <button onClick={handleOnBuyNow}>
                <FaBolt style={{ marginRight: '10px' }} />
                Buy Now
              </button>
            </div>



            <AdditionalInfo
              itemdescription={fetchProductDetails.itemdescription}
              itemid={fetchProductDetails.itemid}
              memberid={memberId}
            />

          </div>
        </div>
      </div >
    </>
  );
};


export default Product;
